import {z} from 'zod';

const categoryShortSchema = z.object({
    id: z.number(),
    name: z.string()
        .max(50, {message: 'Název kategorie může mít maximálně 50 znaků'}),
    categoryNumber: z.number({
        required_error: "Číslo kategorie je povinné",
        invalid_type_error: "Číslo kategorie musí být platné číslo",
    }).positive("Číslo kategorie musí být kladné"),
});

const categorySchema = categoryShortSchema.extend({
    description: z.string()
        .optional()
        .nullable(),
});

type CategoryShort = z.infer<typeof categoryShortSchema>;
type Category = z.infer<typeof categorySchema>;

export {categoryShortSchema, categorySchema, type CategoryShort, type Category};